import { startOfISOWeek, endOfISOWeek, addWeeks, format } from "date-fns";

export function toSentenceCase(str) {
  return str
    .split("_") // Split the string by underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
    .join(" ") // Join the words back with a space
}

export function roundUpToLastTwoDigits(value) {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return format(date, "MMM dd, yyyy"); // Example: "Mar 01, 2025"
}

export function formatYear(year) {
  return year ? year.toString() : "Invalid Year";
}

export function formatToDevanagariStyle(value) {
  // Round to 2 decimal places
  const roundedValue = Math.round((value + Number.EPSILON) * 100) / 100

  // Handle negative sign separately
  const isNegative = roundedValue < 0
  const absoluteValue = Math.abs(roundedValue)

  const [integerPart, fractionalPart] = absoluteValue.toString().split(".")

  // Format integer part with Devanagari-style grouping
  const formattedInteger = integerPart
    .split("")
    .reverse()
    .reduce((acc, digit, index) => {
      if (index === 3 || (index > 3 && (index - 3) % 2 === 0)) {
        acc.push(",")
      }
      acc.push(digit)
      return acc
    }, [])
    .reverse()
    .join("")

  // Combine parts and add negative sign if needed
  const result = fractionalPart
    ? `${formattedInteger}.${fractionalPart}`
    : formattedInteger

  return isNegative ? `-${result}` : result
}


export function formatWeek(weekNumber) {
  const year = Math.floor(weekNumber / 100); // Extract year
  const week = weekNumber % 100; // Extract week number

  // Get the first day of the year
  let firstWeekDate = new Date(year, 0, 4); // Jan 4 is always in the first ISO week
  let startDate = startOfISOWeek(addWeeks(firstWeekDate, week - 1));
  let endDate = endOfISOWeek(startDate);
  return `${startDate.toLocaleDateString("en-US", { month: "short", day: "numeric" })} - ${endDate.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}`;
}